import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Common/Button';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import './LocationUserAccessForm.scss'

export default class LocationUserAccessForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedNewUser: "",
            selectedExistingUser: null,
            availableUsers: []
        };
    }

    addNewUser = () => {
        if (this.state.selectedNewUser) {
            const newUser = this.props.availableUsers.find(m => m.id === this.state.selectedNewUser);
            this.props.addUser(newUser);
            this.setState({ selectedNewUser: "" });
        }
    }

    removeSelectedExistingUser = () => {
        if (this.state.selectedExistingUser) {
            this.props.removeUser(this.state.selectedExistingUser);
        }
    }

    selectNewUser = (csv) => {
        this.setState({ selectedNewUser: csv });
    }

    selectExistingUser = (e) => {
        const obj = this.props.usersWithManualAccess.find(x => x.name === e.target.textContent);
        this.setState({ selectedExistingUser: obj });
    }

    renderUsersWithManualAccess = () => {
        let options = [];
        this.props.usersWithManualAccess.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    renderUsersWithAccessByRule = () => {
        let options = [];
        this.props.usersWithAccessByRule.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    render() {
        //TODO: retrofit common component ListBuilder for below
        return (
            <div className="location-user-access-form">
                <h4>{this.props.locationName}</h4>
                <div className="row">
                    <div className="col-10">
                        <MultiSelectBox 
                            name="location-users" 
                            options={this.props.availableUsers} 
                            idField="id" 
                            valueField="name" 
                            onChange={this.selectNewUser} 
                            selectedValues={this.state.selectedNewUser.toString()} 
                            placeholder="Type to search for a person to add"
                            isMulti={false}
                        />
                    </div>
                    <div className="col-1 ">
                        <button className="btn input-group-btn" onClick={this.addNewUser}><i className="fa fa-plus-circle"></i></button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <span className="has-float-label">
                            <select id="locationUserList" className="form-control mt-3" multiple size="8" onClick={this.selectExistingUser}>
                                {this.renderUsersWithManualAccess()}
                            </select>
                            <label htmlFor="locationUserList">Current Users With Manual Access</label>
                        </span>
                        <div className="text-end">
                            <Button type="button" bootstrapClass="btn btn-outline-secondary mt-2 mb-2" name="btnRemoveUser" text="Remove Selected" onClick={this.removeSelectedExistingUser} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <span className="has-float-label">
                            <select id="locationUserList" className="form-control mt-3" multiple size="8">
                                {this.renderUsersWithAccessByRule()}
                            </select>
                            <label htmlFor="locationUserList">Current Users With Access By Rule</label>
                        </span>
                    </div>
                </div>
            </div>
        );
    }

}

LocationUserAccessForm.propTypes = {
    locationName: PropTypes.string.isRequired,
    usersWithManualAccess: PropTypes.array.isRequired,
    usersWithAccessByRule: PropTypes.array.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    availableUsers: PropTypes.array.isRequired,
    addUser: PropTypes.func.isRequired,
    removeUser: PropTypes.func.isRequired
}
